import { render, staticRenderFns } from "./CustomTableCol.vue?vue&type=template&id=87ed20da&scoped=true&"
import script from "./CustomTableCol.vue?vue&type=script&lang=ts&"
export * from "./CustomTableCol.vue?vue&type=script&lang=ts&"
import style0 from "./CustomTableCol.vue?vue&type=style&index=0&id=87ed20da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ed20da",
  null
  
)

export default component.exports